import { useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "funnel_session_id";

export function getSessionId(): string {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

type EventType = "page_view" | "cta_click" | "survey_start" | "survey_step" | "survey_complete";

export async function trackEvent(
  event_type: EventType,
  extra: { step_index?: number; step_id?: string } = {},
) {
  if (typeof window === "undefined") return;
  try {
    await supabase.from("funnel_events").insert({
      session_id: getSessionId(),
      event_type,
      step_index: extra.step_index ?? null,
      step_id: extra.step_id ?? null,
      path: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
    });
  } catch (e) {
    console.error("trackEvent failed", e);
  }
}

/** Fire a one-time page_view on mount (per pathname). */
export function usePageViewOnce() {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    void trackEvent("page_view");
  }, []);
}
